import { connect } from 'react-redux';
import React, { PureComponent } from 'react';

import img1 from '../../../../assets/svg/1.svg';
import img2 from '../../../../assets/svg/2.svg';
import img3 from '../../../../assets/svg/3.svg';

import store from '../../../../redux/store';
import { AFTER_DIALOG_REPORT } from '../../../../redux/actions/dialogsActions';
import MixPanelService from '../../../../system/services/MixPanelService';
import { Button, Image, Input } from 'antd';

class NewMessagesPopup extends PureComponent {
    constructor(props) {
        super(props);

        this.handlePopupClick = this.handlePopupClick.bind(this);
        this.handleSetRate = this.handleSetRate.bind(this);
        this.state = {
            rate: null,
            isBtnDisabled: true,
        };
    }

    handlePopupClick(e) {
        if (this.props.dialog) {
            MixPanelService.track('Gave feedback', {
                Name: this.props.account.account_info.name + ' ' + this.props.account.account_info.last_name,
                Email: this.props.account.account_info.email,
                university_id: this.props.dialog.university_id,
            });
        }
        console.log('e.currentTarget.dataset.value', e.currentTarget.dataset);
        store.dispatch({
            type: AFTER_DIALOG_REPORT,
            payload: {
                dialog_id: this.props.dialog.id,
                user_mark: this.state.rate,
                university_mark: e.currentTarget.dataset.value === 'true',
            },
        });
        this.handleCloseReport();
    }

    handleSetRate(e, rate) {
        this.setState({
            isBtnDisabled: false,
            rate,
        });
    }

    render() {
        const { dialog, handleCloseReport } = this.props;
        this.handleCloseReport = handleCloseReport.bind(this);
        if (dialog.members[0]) var member = dialog.members[0];

        return (
            <div className="remodal close-conversation" id="close-conversation" data-remodal-id="close-conversation">
                <h2 className="modal-name">Thanks for chatting!</h2>
                <p className="modal-subtext">
                    Please rate your conversation with {member ? member.name : 'this ambassador'}
                </p>
                <div className="rate-row">
                    <label className="rate-label" onClick={(e) => this.handleSetRate(e, -1)}>
                        <Input type="radio" className="radio-input" name="rate" />
                        <Image className="rate-icon" src={img3} alt="Rate the conversation: bad" />
                        <p>Negative</p>
                    </label>

                    <label className="rate-label" onClick={(e) => this.handleSetRate(e, 0)}>
                        <Input type="radio" className=" radio-input" name="rate" />
                        <Image className="rate-icon" src={img2} alt="Rate the conversation: average" />
                        <p>Neutral</p>
                    </label>

                    <label className="rate-label" onClick={(e) => this.handleSetRate(e, 1)}>
                        <Input type="radio" className="radio-input" name="rate" />
                        <Image className="rate-icon" src={img1} alt="Rate the conversation: good" />
                        <p>Positive</p>
                    </label>
                </div>
                <label className="modal-label mod-center">
                    <p className="modal-label-text">
                        Are you more likely to choose this institution after this conversation?
                    </p>
                    <div className="radio-row">
                        <Button
                            data-value={false}
                            onClick={this.handlePopupClick}
                            className="sign-up-sbm"
                            aria-label="No"
                            disabled={this.state.isBtnDisabled}
                        >
                            No
                        </Button>
                        <Button
                            data-value={true}
                            onClick={this.handlePopupClick}
                            className="sign-up-sbm"
                            aria-label="Yes"
                            disabled={this.state.isBtnDisabled}
                        >
                            Yes
                        </Button>
                    </div>
                </label>
            </div>
        );
    }
}

export default connect((state) => {
    return {
        account: state.account,
        messages: state.messages,
    };
})(NewMessagesPopup);
